import { Col, Row, Space } from 'antd';
import React, { useMemo, useState } from 'react';

import MapLoader from '../../components/MapLoader';
import LinkText from '../../components/Text/LinkText';
import { getCenterCoordinates, getStaticMapImageURL } from '../../utils/map';
import { getActiveRoutes } from '../../views/trips/trips-page-helpers';

const TripAnomaliesMap = props => {
  const { t, tripAnomaly, lineColor, onViewFullScreenClick, journeyGeoJson = {}, tripType } = props;

  const [activeRoutes, setActiveRoutes] = useState([]);
  const [mapCenter, setMapCenter] = useState();

  const map = useMemo(() => {
    if (!journeyGeoJson || !journeyGeoJson.geometry?.coordinates) return null;

    let routes, center;
    let mapHasError;

    try {
      routes = getActiveRoutes({ journeyGeoJson });
      mapHasError = !routes.length;

      if (!mapHasError) {
        const routeColor = lineColor || (tripType === 'adjusted' ? '#ff8c42' : '#6b99f0');
        routes = routes.map(route => ({
          ...route,
          color: routeColor,
        }));
        const centerConfig = getCenterCoordinates(journeyGeoJson.geometry.coordinates);
        center = centerConfig.center;
        setMapCenter(center);
        setActiveRoutes(routes);
      }
    } catch {
      mapHasError = true;
    }

    return mapHasError ? (
      <Row
        justify="center"
        align="middle"
        style={{ width: 563, height: 304, background: '#F6F7F8' }}
      >
        <Col flex="179px">
          <MapLoader text={t('errorLoadingMap')} />
        </Col>
      </Row>
    ) : (
      <img
        alt="Trip map"
        style={{
          cursor: typeof onViewFullScreenClick === 'function' ? 'pointer' : 'initial',
          width: '563px',
          height: '304px',
        }}
        src={getStaticMapImageURL(routes, journeyGeoJson, 563, 304, true, lineColor)}
        width="100%"
        height="100%"
        title={typeof onViewFullScreenClick === 'function' ? t('viewDetailedRoute') : undefined}
        onClick={() => {
          if (typeof onViewFullScreenClick === 'function') {
            onViewFullScreenClick(tripAnomaly, routes, center, tripType);
          }
        }}
      />
    );
  }, [t, tripAnomaly, lineColor, onViewFullScreenClick, journeyGeoJson, tripType]);

  const isLoading = !journeyGeoJson?.geometry?.coordinates;

  if ((!activeRoutes.length || !mapCenter || !tripAnomaly) && (isLoading || map === null)) {
    return (
      <Row
        justify="center"
        align="middle"
        style={{ width: 563, height: 304, background: '#F6F7F8' }}
      >
        <Col flex="179px">
          <MapLoader text={t('loadingMap')} />
        </Col>
      </Row>
    );
  }

  return (
    <Space direction="vertical" size="small">
      <div>{map}</div>
      {typeof onViewFullScreenClick === 'function' && (
        <LinkText
          onClick={() => {
            onViewFullScreenClick(tripAnomaly, activeRoutes, mapCenter, tripType);
          }}
        >
          {t('viewDetailedRoute')}
        </LinkText>
      )}
    </Space>
  );
};

export default TripAnomaliesMap;
